import { useMemo } from 'react';

import { IEventByDateItem } from '@entities/eventJournal';

export const useGetEventItemData = ({
    currentEventIdQueryState,
    journalEventsList,
}: {
    currentEventIdQueryState: string;
    journalEventsList: IEventByDateItem[];
}) =>
    useMemo(() => {
        if (!currentEventIdQueryState || !journalEventsList?.length) {
            return null;
        }

        const day = journalEventsList.find((d) =>
            d?.events?.text?.some((ev) => String(ev.id) === currentEventIdQueryState)
        );

        const eventItemData = day?.events?.text?.find(
            (ev) => String(ev.id) === currentEventIdQueryState
        );
        return {
            eventDate: day?.date ?? '',
            eventItemData,
        };
    }, [currentEventIdQueryState, journalEventsList]);
